<template>
  <div class="body">
    <div class="search-container">
      <i class="fas fa-search icone-search"></i>
      <input v-model="buscaEpi" class="input-pesquisar" placeholder="Pesquisar EPI's"/>
    </div>
    <div class="container-add-epi">
        <div class="epi" v-for="epi in dataFiltroEPI" v-bind:key="epi.id">
            <div class="nome-epi">
                {{epi.descricao}}
            </div>
            <div class="button-epi-selecionado">
                <div class="button" :id="epi.id" @click="AdicionarEpi(epi)"><i class="fas fa-plus icone-add"></i></div>
            </div>
        </div>
    </div>
    <div class="d-flex container_cancel_save">
        <div class="cancelar">
            <button class="button-cancel" @click="cancel">CANCELAR</button>
        </div>
        <div class="criar">
            <button class="button-save"  @click="identificarElementosClicados">ADICIONAR</button>
        </div>
    </div>
  </div>

</template>

<script>
import addEpiApr from './addEpiApr'
export default addEpiApr
</script>

  <style scoped>
  .body{
    width: 100%;
    padding: 1rem;
  }
  .nome-epi{
    color: #747474;
    font-size: 13px;
    font-family: 'Segoe UI';
    width: 100%;
  }
  .container-add-epi{
    width: 100%;
    height: fit-content;
    border-bottom: 1px solid rgb(233, 233, 233);
    height: 15rem;
    overflow: auto;
    border-bottom: 1px solid #D4D4D4;
    border-radius: 10px;
  }
  .container-add-epi::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .container-add-epi::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      border-radius: 10px;
  }
  .container-add-epi::-webkit-scrollbar-thumb {
      background: #dad7d7;
      border-radius: 10px;
  }
  .epi {
    border-top: 1px solid  rgb(233, 233, 233);
    padding: 0.5rem;
    width: 100%;
    display: flex;
    width: 100%;
  }
  .button-epi-selecionado{
    display: flex;
    width: 10%;
    justify-content: end;
  }
  .button{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgb(216, 216, 216);
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
  }
  .button.clicked {
        background-color: #008144; /* Cor de fundo alterada */
   }

  .icone-add {
    color: white;
    font-size: 11px;
  }
 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 20px;
 }

 .button-cancel{
   background-color: #b60000;
   color: white;
 }
 .button-save{
  background-color: darkgreen;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.input-pesquisar{
    width: 100%;
    margin-top: 0.5rem;
    height: 2rem;
    border: 1px solid rgb(216, 216, 216);
    border-radius: 2px;
    padding-left: 2rem;
    margin-bottom: 1rem;
}
.icone-search{
    position: absolute;
    left: 10px;
    top: 18px;
    font-size: 14px;
}
.search-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/addEpiApr/addEpiApr.vue